import { makeVar } from '@apollo/client';

export const modalOpenState = makeVar<boolean | undefined>(false);
